var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 11.0002H5.91L7.21 9.71019C7.3983 9.52188 7.50409 9.26649 7.50409 9.00019C7.50409 8.73388 7.3983 8.47849 7.21 8.29019C7.0217 8.10188 6.7663 7.99609 6.5 7.99609C6.2337 7.99609 5.9783 8.10188 5.79 8.29019L2.79 11.2902C2.69627 11.3831 2.62188 11.4937 2.57111 11.6156C2.52034 11.7375 2.4942 11.8682 2.4942 12.0002C2.4942 12.1322 2.52034 12.2629 2.57111 12.3848C2.62188 12.5066 2.69627 12.6172 2.79 12.7102L5.79 15.7102C5.88296 15.8039 5.99356 15.8783 6.11542 15.9291C6.23728 15.9798 6.36799 16.006 6.5 16.006C6.63201 16.006 6.76272 15.9798 6.88458 15.9291C7.00644 15.8783 7.11704 15.8039 7.21 15.7102C7.30373 15.6172 7.37812 15.5066 7.42889 15.3848C7.47966 15.2629 7.5058 15.1322 7.5058 15.0002C7.5058 14.8682 7.47966 14.7375 7.42889 14.6156C7.37812 14.4937 7.30373 14.3831 7.21 14.2902L5.91 13.0002H20.05C20.298 12.9881 20.5327 12.8841 20.7083 12.7085C20.8839 12.5329 20.9879 12.2982 21 12.0502V12.0002C21.0003 11.7434 20.9019 11.4963 20.725 11.3102C20.5481 11.124 20.3065 11.013 20.05 11.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 17H3.95C3.42533 17 3 17.4253 3 17.95V18.05C3 18.5747 3.42533 19 3.95 19H20.05C20.5747 19 21 18.5747 21 18.05V17.95C21 17.4253 20.5747 17 20.05 17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 5H3.95C3.42533 5 3 5.42533 3 5.95V6.05C3 6.57467 3.42533 7 3.95 7H20.05C20.5747 7 21 6.57467 21 6.05V5.95C21 5.42533 20.5747 5 20.05 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrow);
export default __webpack_public_path__ + "static/media/menuArrow.d47f5f3a3aa23c49e78d5e2f9586fb37.svg";
export { ForwardRef as ReactComponent };